<template>
	<div class="container">
		<div class="sidebar">
		  <my-component></my-component>
		</div>
		<div class="content" >
			<div class="page-header" >
			地址信息</div>
  <div v-if="isAddress">
    <div class="block">
      <van-cell-group title="地址信息" >
        <van-cell
		title="地址信息"
          :value="blockInfo.address"
          :border="false"
        />
        <van-cell
          style="color: #213654"
          :value="blockInfo.block_hash"
          :border="false"
        />
        <van-cell
          title="存证数量"
          :value="blockInfo.txs.length"
          :border="false"
        />
        <van-cell title="时间" :value="blockInfo.time" :border="false" />
      </van-cell-group>
    </div>
    <div class="block_txs">
      <div class="block">
        <van-cell-group title="普通存证"> </van-cell-group>
        <div
          class="mobile_cell"
          v-for="(item, index) in tableData"
          :key="index + ''"
        >
          <van-cell-group :border="false">
            <van-cell title="存证哈希" :value="item.tx_hash" :border="false">
              <template>
                <router-link
                  style="text-decoration: none"
                  :to="{
                    path: '/txDetail',
                    query: { tx_hash: item.tx_hash },
                  }"
                  >{{ item.tx_hash }}
                </router-link>
              </template>
            </van-cell>
            <!-- <van-cell title="memo"  :border="false">
              <template>
                <router-link
                  style="text-decoration: none"
                  :to="{
                    path: '/goodsAddress',
                  }"
                  >全程追溯
                </router-link>
              </template>
            </van-cell> -->
            <!-- <van-cell title="动作类型" value="send" :border="false" /> -->
            <van-cell title="存证时间" :value="item.time" :border="false" />
            <van-cell title="存证高度" :value="item.height" :border="false" />
            <!-- <van-cell title="存证金额" :value="item.amount" :border="false" />
            <van-cell
              title="存证小费"
              :value="item.gas + 'gas'"
              :border="false"
            /> -->
          </van-cell-group>
        </div>
      </div>
    
    </div>
  </div>
  <div v-else class="noBox">暂时未找到数据</div>
  </div>
  </div>
</template>

<script>
	import MyComponent from '@/components/MyComponent.vue';
const  sortRule = function(a,b) {
    return b.height- a.height;
}
export default {
	components: { MyComponent },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      blockInfo: null,
      isAddress: "",
      tableData: [],
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.reload();
      },
      immediate: true,
    },
  },

  mounted() {},
  methods: {
    reload() {
      if (this.$route.query.address) {
        this.getBlockTable(this.$route.query.address);
      } else {
        this.$notify({
          title: "提示",
          message: "浏览器网址不对",
          type: "warning",
          duration: 1000,
        });
      }
    },
    getPage(value) {},
    getBlockTable(address) {
      this.$http.get(`${block_ip}address/${address}`).then((res) => {
        let data = res.data.data;
        if (data) {
          this.blockInfo = data;
          this.tableData = data.txs.sort(sortRule);
          this.isAddress = address;
        } else {
          this.$notify({
            title: "提示",
            message: "传入地址有误!",
            type: "warning",
            duration: 1000,
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.block_txs {
  margin-top: 20px;
}
.mobile_cell {
 
}
.custom-title {
  margin-right: 4px;
  vertical-align: middle;
}

.search-icon {
  font-size: 16px;
  line-height: inherit;
}
.van-cell__value {
  flex: 3;
}
.van-cell__value {
  text-align: left;
  // white-space: nowrap;
  // text-overflow: ellipsis;
  // overflow: hidden;
  color:white
}
.noBox {
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  margin: 10px 12px;
}
.van-cell {
  padding: 10px 16px 10px 16px;
  background-color: rgb(26,35,45);
  color:white
}

.block {
  margin: 0 12px;
  background-color: rgb(26,35,45);
}
.pagination {
  margin: 0 12px;
}
.van-cell-group__title {
  padding: 25px 10px 8px;
  font-size: 20px;
  color:white;
  border: none;
  font-weight: bolder;
  
  
}
.container {
	  display: flex;
	  min-height: 100vh;
	}
	
	.sidebar {
	 
	  height: 100vh; /* 侧边栏高度 */
	  
	}
	
	.content {
	 
	  width:800px;
	  padding: 20px; /* 内容区域的内边距 */
	  background-color: rgb(37,49,63);
	}
	.page-header {
	  padding: 15px; /* 根据需要调整内边距 */
	  background-color: rgb(37,49,63); /* 背景颜色 */
	  position: relative; /* 相对定位，如果需要定位子元素 */
	  font-size:23px;
	  color:white;
	  font-weight:bold;
	
	   
	} 
	a {
	  color: white ; /* 设置链接的颜色为黑色 */
	  text-decoration: none; /* 移除下划线 */
	}
</style>
